import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a47b186"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "upload dev page", -1))
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { class: "pill invitation-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Invite #:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date:", -1))
const _hoisted_6 = { class: "pill name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "name:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "attending:", -1))
const _hoisted_9 = {
  key: 0,
  class: "pill advice"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "advice or joke:", -1))
const _hoisted_11 = {
  key: 1,
  class: "pill song"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "song recommendations:", -1))
const _hoisted_13 = {
  key: 2,
  class: "pill reason"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "reason for declining:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!_ctx.isAdminLoggedIn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signInWithGoogle && _ctx.signInWithGoogle(...args)))
        }, "Sign in"))
      : _createCommentVNode("", true),
    (_ctx.isAdminLoggedIn)
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "file",
          ref: "theFile",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitted && _ctx.submitted(...args)))
        }, null, 544))
      : _createCommentVNode("", true),
    (_ctx.isAdminLoggedIn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadLatestRevps && _ctx.downloadLatestRevps(...args)))
        }, "Download Latest RSVPs"))
      : _createCommentVNode("", true),
    (_ctx.latestRsvps != null)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestRsvps, (rsvpView) => {
            return (_openBlock(), _createElementBlock("li", {
              key: rsvpView.name
            }, [
              _createElementVNode("p", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(rsvpView.partyId), 1)
              ]),
              _createElementVNode("p", {
                class: "pill",
                style: _normalizeStyle({'background-color': _ctx.dateColor(rsvpView.date)})
              }, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(new Date(rsvpView.date).toLocaleDateString()), 1)
              ], 4),
              _createElementVNode("p", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(rsvpView.name), 1)
              ]),
              _createElementVNode("p", {
                class: _normalizeClass(["pill", rsvpView.attending ? 'attending' : 'notAttending'])
              }, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(rsvpView.attending ? 'Yes' : 'No'), 1)
              ], 2),
              (rsvpView.attending)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(rsvpView.adviceOrJoke), 1)
                  ]))
                : _createCommentVNode("", true),
              (rsvpView.attending)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(rsvpView.songRecommendation), 1)
                  ]))
                : _createCommentVNode("", true),
              (!rsvpView.attending)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(rsvpView.reasonForDeclining), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}